import type { IxcMutualfundsV1MutualFundsTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const MUTUAL_FUNDS_TASK_BASE_PATH = getResolvedPath('/clearing/operations/mutualfunds/task');

export const getMutualFundsTaskPath: EntityPathBuilder<IxcMutualfundsV1MutualFundsTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return MUTUAL_FUNDS_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.mutualFundsTaskId) {
        return undefined;
      }

      return getResolvedPath(`${MUTUAL_FUNDS_TASK_BASE_PATH}/$taskId`, { taskId: context.keys.mutualFundsTaskId, ...context.keys });
    }
  }
};

export function getMutualFundsTaskDetailPath(mutualFundsTaskId: string | undefined) {
  if (!mutualFundsTaskId) {
    return undefined;
  }

  return getMutualFundsTaskPath({ kind: 'detail', keys: { mutualFundsTaskId } });
}
